import { useState } from "react";
import Widget from "../_components/Widget";
import InviteController from "../controllers/InviteController";
import { usePlan } from "../_providers/PlanProvider";
import { useAuth } from "../_providers/AuthProvider";

const Invite = () => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");

    const [loading, setLoading] = useState(false);
    const { selectedPlan } = usePlan();
    const { user } = useAuth();

    const inviteMember = (email: string) => {
        if(!selectedPlan) {
            setError("No plan selected");
            setLoading(false);
            return;
        }
        if(!user) {
            setError("Authentication Error");
            setLoading(false);
            return;
        }
        InviteController.createInvite(`${user?.displayName} (${user?.email}) has invited you to ${selectedPlan.name}.`, email, selectedPlan.uid).then(() => {
            setEmail("");
        }).catch((error) => {
            setError(error.message);
        }
        );
    }

    if (selectedPlan?.owner !== user?.uid) return null;
    if(error) return <div>{error}</div>;
    return (
        <Widget title="Invite Member" flex={1} minWidth="150px">
            <div style={{display: "flex"}}>
            <input
                type="text"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{padding: 10, flex: 2, borderRadius: "2px 0 0 2px", border: "1px solid #ccc"}}
            />
            <button className="input-btn" style={{borderRadius: "0 2px 2px 0"}} onClick={() => inviteMember(email)}><i className="fa-solid fa-plus" /></button>
            </div>
        </Widget>
    );
}

export default Invite;